import { Component, Input } from '@angular/core';

@Component({
  selector: 'gtd-number-status',
  templateUrl: './number-status.component.html',
})
export class NumberStatusComponent {
  @Input() data: string;
  @Input() statusNames = [$localize`:@@common.blocked:Blocked`, $localize`:@@common.active:Active`, $localize`:@@common.pending:Pending`];
}
